import React, { useEffect, useState } from "react";
import "./Nav.scss";
import { Link } from "react-router-dom";
import { API_SWIP_URLS } from "../../Shared/Constant";
import { DecodeBase64 } from "..";
import useApiCall from "../../Utilies/useApiCall";

const SideBar = ({setShowNav}) => {
    const [menu, setMenu] = useState(JSON.parse(localStorage.getItem("sideBar")))
  const uid = window.localStorage.getItem("user-msisdn");
  useEffect(() => {
    
    setMenu(JSON.parse(localStorage.getItem("sideBar")))
  }, []);
  const handleCloseSidebar = () => {
    // Implement your logic to close the sidebar here
    setShowNav(false)
  };

  if (!menu) return null;

  console.log(menu, "menu");
  return (
    <nav className="navigation pl-4 ">
      <div>
        {menu?.length &&
          menu?.map((items, i) => {
            return (
              <div className="mt-1 mb-1" key={i}>
                <Link to={items?.link} className="text-[#4b0083]" onClick={handleCloseSidebar} onBlur={handleCloseSidebar} >
                  {DecodeBase64(items?.title)}
                </Link>
              </div>
            );
          })}
      </div>
    </nav>
  );
};
export default SideBar;
